import { render, staticRenderFns } from "./QuickLeadUpdateModal.vue?vue&type=template&id=b1242730"
import script from "./QuickLeadUpdateModal.vue?vue&type=script&lang=js"
export * from "./QuickLeadUpdateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports